module.exports = __webpack_public_path__ + "img/aParty_032523_C.791b99b1.jpg";